module.exports = __webpack_public_path__ + "img/thumbnail_Blackbuck_f_leucistic.23ad6581.png";